import { getOrganizationViewUrl } from '../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../utils/routing/reactRoute'

// Every URL SalesReport is reachable at.
// These URLs are served by a single <Route> (see SalesReportRoute) rather than
// one per path, so that switching variants keeps the report mounted.
export const getSalesReportRoutePaths = (organizationUrl: string): string[] => {
  const { salesReport } = reactRoute.organization

  return [
    salesReport.getMainRoute(),
    salesReport.getSalesOverviewRoute(),
    salesReport.getSalesByCustomerRoute(),
    salesReport.getSalesByItemRoute(),
  ].map((route) => getOrganizationViewUrl(organizationUrl, route))
}
